<template>
  <span>
    <span v-show="$store.getters['app/overlays'].show_start_selector_overlay">
      <img draggable="false" id="mini_logo" src="./../assets/images/Asset 49.png" alt="">
      
      <span id="top_text" v-html="content.name"></span>
      <span id="text_description" v-html="content.text"></span>

      <img v-if="content.type == 'open'" draggable="false" id="mini_closet_open" src="./../assets/images/Asset 84.png" alt="">
      <img v-else draggable="false" id="mini_closet_closed" src="./../assets/images/Asset 84_closed.png" alt="">

      <img draggable="false" v-if="content.image == 76" id="image_76" class="item" src="./../assets/images/Asset 76.png" alt="">
      <img draggable="false" v-if="content.image == 77" id="image_77" class="item" src="./../assets/images/Asset 77.png" alt="">
      <img draggable="false" v-if="content.image == 78" id="image_78" class="item" src="./../assets/images/Asset 78.png" alt="">
      <img draggable="false" v-if="content.image == 79" id="image_79" class="item" src="./../assets/images/Asset 79.png" alt="">
      <img draggable="false" v-if="content.image == 80" id="image_80" class="item" src="./../assets/images/Asset 80.png" alt="">
      <img draggable="false" v-if="content.image == 81" id="image_81" class="item" src="./../assets/images/Asset 81.png" alt="">
      <img draggable="false" v-if="content.image == 82" id="image_82" class="item" src="./../assets/images/Asset 82.png" alt="">
      <img draggable="false" v-if="content.image == 83" id="image_83" class="item" src="./../assets/images/Asset 83.png" alt="">
      <img draggable="false" v-if="content.image == 107" id="image_107" class="item" src="./../assets/images/Asset 107.png" alt="">
      <img draggable="false" v-if="content.image == 49" id="image_49" class="item" src="./../assets/images/49.jpeg" alt="">
      <img draggable="false" v-if="content.image == 100" id="image_49" class="item" src="./../assets/images/Asset 100.png" alt="">
      <img draggable="false" v-if="content.image == 102" id="image_49" class="item" src="./../assets/images/Asset 102.png" alt="">
      <img draggable="false" v-if="content.image == 112" id="image_112" class="item" src="./../assets/images/Asset 112.png" alt="">
      <img draggable="false" v-if="content.image == 109" id="image_49" class="item" src="./../assets/images/Asset 109.png" alt="">
      <img draggable="false" v-if="content.image == 1" id="image_1" class="item" src="./../assets/images/Asset 1.png" alt="">
      <img draggable="false" v-if="content.image == 113" id="image_49" class="item" src="./../assets/images/Asset 113.png" alt="">
      <img draggable="false" v-if="content.image == 128" id="image_49" class="item" src="./../assets/images/Asset 128.png" alt="">
      <img draggable="false" v-if="content.image == 108" id="image_108" class="item" src="./../assets/images/Asset 108.png" alt="">
      <img draggable="false" v-if="content.image == 129" id="image_129" class="item" src="./../assets/images/Asset 129.png" alt="">
      <img draggable="false" v-if="content.image == 130" id="image_130" class="item" src="./../assets/images/Asset 130.png" alt="">
      <img draggable="false" v-if="content.image == 126" id="image_126" class="item" src="./../assets/images/Asset 126.png" alt="">
      <img draggable="false" v-if="content.image == 111" id="image_111" class="item" src="./../assets/images/Asset 111.png" alt="">

      <img draggable="false" v-if="content.image == 83" class="person" src="./../assets/images/persons/83.jpeg" alt="">
      <img draggable="false" v-if="content.image == 76" class="person" src="./../assets/images/persons/76.jpeg" alt="">
      <img draggable="false" v-if="content.image == 77" class="person" src="./../assets/images/persons/77.jpeg" alt="">
      <img draggable="false" v-if="content.image == 78" class="person" src="./../assets/images/persons/78.jpeg" alt="">
      <img draggable="false" v-if="content.image == 79" class="person" src="./../assets/images/persons/79.jpeg" alt="">
      <img draggable="false" v-if="content.image == 82" class="person" src="./../assets/images/persons/82.jpeg" alt="">
      <img draggable="false" v-if="content.image == 107" class="person" src="./../assets/images/persons/107.jpeg" alt="">
      <img draggable="false" v-if="content.image == 49" class="person" src="./../assets/images/persons/49.jpeg" alt="">
      <img draggable="false" v-if="content.image == 100" class="person" src="./../assets/images/persons/100.jpeg" alt="">
      <img draggable="false" v-if="content.image == 112" class="person" src="./../assets/images/persons/112.jpeg" alt="">
      <img draggable="false" v-if="content.image == 1" class="person" src="./../assets/images/persons/1.jpeg" alt="">
      <img draggable="false" v-if="content.image == 113" class="person" src="./../assets/images/persons/113.jpeg" alt="">
      <img draggable="false" v-if="content.image == 129" class="person" src="./../assets/images/persons/129.jpeg" alt="">
      <img draggable="false" v-if="content.image == 130" class="person" src="./../assets/images/persons/130.jpeg" alt="">
      <img draggable="false" v-if="content.image == 126" class="person" src="./../assets/images/persons/126.jpeg" alt="">
      <img draggable="false" v-if="content.image == 111" class="person" src="./../assets/images/persons/111.jpeg" alt="">
    </span>
  </span>
</template>

<script>
export default {
  name: "Start",
  mounted() {},

  created() {},
  destroyed() {},

  data() {
    return {};
  },

  methods: {
    goToHome() {
      this.$router.push('/');
      this.$store.dispatch('app/asyncUpdateOverlay', {
          show_start_menu_overlay: true,
          show_start_selector_overlay: false,
      });
    },
    goToGamePage() {
      this.$router.push('/game');
    },
    GoToPhagwaGame() {
      this.$router.push('/phagwagame');
    },
    GoToKerstmisGame() {
      this.$router.push('/kerstmisgame');
    },
  },

  computed: {
    content: function() {
      return this.$store.getters['app/content']
    }
  }
};
</script>

<style>
  #top_text {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 16%;
    width: 55%;
    left: 36%;
    color: #6ba544;
    font-size: 4vw;
    text-align: center;
  }
  #text_description {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 21%;
    width: 45%;
    left: 40%;
    height: 44%;
    overflow: scroll;
    color: black;
    font-size: 1.5vw;
    text-align: center;
  }

  #mini_logo {
    position: absolute;
    margin-top: 3%;
    right: 29%;
    width: 15%;
    z-index: 1;
  }

  #mini_closet_open {
    position: absolute;
    margin-top: 14%;
    left: 1.5%;
    width: 36%;
    z-index: 0;
  }
  #mini_closet_closed {
    position: absolute;
    margin-top: 11%;
    left: 8%;
    width: 23%;
    z-index: 0;
  }

  .item {
    position: absolute;
    margin-top: 17.5%;
    left: 13.5%;
    width: 12%;
    z-index: 0;
  }
  .person {
    position: absolute;
    margin-top: 33.5%;
    left: 15%;
    width: 8.5%;
    z-index: 0;
  }

  #image_76 {
    left: 17.5%;
    width: 4%;
  }

  #image_77 {
    left: 15%;
    width: 9%;
  }

  #image_78 {
    left: 17.2%;
    width: 5%;
  }

  #image_79 {
    left: 15%;
    width: 9%;
  }

  #image_80 {
    left: 16%;
    width: 8%;
  }

  #image_107 {
    left: 18%;
    width: 4%;
  }

  #image_112 {
    left: 16.5%;
    width: 6%;
  }

  #image_1 {
    left: 12%;
    width: 15%;
  }
  #image_108 {
    left: 16%;
    width: 9%;
  }
  #image_129 {
    left: 15.5%;
    width: 8%;
  }
  #image_130 {
    left: 15%;
    width: 9%;
  }
  #image_126 {
    left: 15%;
    width: 9%;
  }
  #image_111 {
    left: 14.5%;
    width: 10%;
  }
  #image_81 {
    left: 14%;
    width: 11%;
  }
</style>
